/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Buttons from "../../../components/ui/button/Buttons";
import ToastService from "../../../services/toastService/ToastService";
import {
  useAddEditTeamMembersMutation,
  useLazyGetAllUserByTeamIDQuery
} from "../../../app/services/teamMemberAPI";
import { teamMemberFormData } from "../config/TeamMembers.data";
import { useSelector } from "react-redux";
import FormCreator from "../../../components/finalForms/FormCreator";
import { mapDropdownOptions } from "../../../components/finalForms/libs/mapDropdownOptions";

const AddEditTeamMembers = (props) => {

  const teamMemberRef = useRef();

  const [formData, setFormData] = useState({ ...teamMemberFormData });

  const teamId = useSelector((state) => state.teamProjectManagement.teamData.teamId);

  const [addEditTeamMembers, {
    isLoading: isTeamMemberLoading,
    isSuccess: isSucessAddEditTeamMember,
    data: addEditTeamMemberData,
  },] = useAddEditTeamMembersMutation();


  const [getAllUserByTeamID, {
    isFetching: isUserNameFetching,
    isSuccess: isUserName,
    data: UserNameData,
  },] = useLazyGetAllUserByTeamIDQuery();

  useEffect(() => {
    if (teamId) {
      getAllUserByTeamID(teamId);
    }
  }, [teamId]);

  const handleSubmit = () => {
    const TeamMemberData = teamMemberRef.current.getFormData();
    if (TeamMemberData) {
      const userIds = TeamMemberData.userId.join(",");
      const requestData = {
        ...TeamMemberData,
        teamId: teamId,
        UserIds: userIds
      }
      addEditTeamMembers(requestData);
    }
  };

  useEffect(() => {
    if (!isUserNameFetching && isUserName && UserNameData) {
      const updatedFormData = { ...formData }
      mapDropdownOptions(
        updatedFormData,
        "TeamMember",
        "userId",
        UserNameData,
        "userId",
        "userName"
      );
      setFormData(updatedFormData);
    }
  }, [isUserNameFetching, isUserName, UserNameData]);


  useEffect(() => {
    if (isSucessAddEditTeamMember && addEditTeamMemberData) {
      if (addEditTeamMemberData.errorMessage?.includes("exists")) {
        ToastService.warning(addEditTeamMemberData.errorMessage);
        return;
      }
      else {
        ToastService.success(addEditTeamMemberData.errorMessage);
        backToList();
      }
    }
  }, [isSucessAddEditTeamMember, addEditTeamMemberData]);


  const backToList = () => {
    props.onClose();
  };

  return (
    <>
      <form>
        <div className="row mt-0 edit-project-form">
          <FormCreator config={formData} ref={teamMemberRef} />
        </div>
      </form>
      <div className="d-flex justify-content-end">
        <Buttons
          buttonTypeClassName="dark-btn"
          buttonText="Cancel"
          onClick={backToList}
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          buttonText="Add"
          isLoading={isTeamMemberLoading}
          onClick={handleSubmit}
        />
      </div>
    </>
  );
};


AddEditTeamMembers.propTypes = {
  initData: PropTypes.shape({
    teamId: PropTypes.number,
    userId: PropTypes.number,
  }),
};
export default AddEditTeamMembers;